import { tv } from "tailwind-variants";

export const input = tv({
    base: [],

    variants: {
        inputType: {
            file: "tw:block tw:w-full",
            range: "tw:block tw:w-full",
            radio: "tw:group-[*]/formgrouptoggle:absolute tw:group-[*]/formgrouptoggle:-ml-5 tw:group-[*]/formgrouptoggle:mt-1.75",
            checkbox:
                "tw:group-[*]/formgrouptoggle:absolute tw:group-[*]/formgrouptoggle:-ml-5 tw:group-[*]/formgrouptoggle:mt-1.75",
            default: [
                "tw:h-10 tw:block tw:w-full tw:bg-background tw:text-black tw:border tw:border-grey-input tw:transition-shadow tw:z-10",
                "tw:focus:not-disabled:not-read-only:ring-inset tw:focus:not-disabled:not-read-only:ring-3 tw:focus:not-disabled:not-read-only:ring-information/40 tw:focus:not-disabled:not-read-only:border-information tw:focus-visible:outline-none! tw:focus:z-20 tw:focus-visible:z-20",
                "tw:disabled:bg-muted tw:read-only:bg-muted tw:disabled:text-muted-foreground tw:read-only:text-muted-foreground",
                "tw:rounded-sm!",
                "tw:group-[*]/inputgroup:not-first:rounded-l-none!",
                "tw:group-[*]/inputgroup:not-last:rounded-r-none!",
                "tw:group-[*]/inputgroup:not-last:-mr-px!"
            ]
        },
        inputSize: {
            sm: "tw:pl-2 tw:pr-2 tw:py-1 tw:text-sm!",
            md: "tw:pl-3 tw:pr-3  tw:py-1.5 tw:text-base!",
            lg: "tw:pl-4 tw:pr-4 tw:py-2 tw:text-xl!"
        },
        invalid: {
            true: [
                "tw:border-danger! tw:ring-danger/40!",
                "tw:bg-no-repeat tw:bg-position-[right_0.5rem_center] tw:bg-size-[1.25rem]",
                "tw:bg-[url('data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%2012%2012%27%20width%3D%2712%27%20height%3D%2712%27%20fill%3D%27none%27%20stroke%3D%27%23b90000%27%3E%3Ccircle%20cx%3D%276%27%20cy%3D%276%27%20r%3D%274.5%27%2F%3E%3Cpath%20stroke-linejoin%3D%27round%27%20d%3D%27M5.8%203.6h.4L6%206.5z%27%2F%3E%3Ccircle%20cx%3D%276%27%20cy%3D%278.2%27%20r%3D%27.6%27%20fill%3D%27%23b90000%27%20stroke%3D%27none%27%2F%3E%3C%2Fsvg%3E')]"
            ]
        },
        valid: {
            true: [
                "tw:border-success! tw:ring-success/40!",
                "tw:bg-no-repeat tw:bg-position-[right_0.5rem_center] tw:bg-size-[1.25rem]",
                "tw:bg-[url('data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%208%208%27%3E%3Cpath%20fill%3D%27%23378700%27%20d%3D%27M2.3%206.73L.6%204.53c-.4-1.04.46-1.4%201.1-.8l1.1%201.4%203.4-3.8c.6-.63%201.6-.27%201.2.7l-4%204.6c-.43.5-.8.4-1.1.1z%27%2F%3E%3C%2Fsvg%3E')]"
            ]
        }
    },

    compoundVariants: [
        {
            inputType: "default",
            invalid: true,
            inputSize: "sm",
            class: "tw:pr-8"
        },
        {
            inputType: "default",
            invalid: true,
            inputSize: "md",
            class: "tw:pr-9"
        },
        {
            inputType: "default",
            invalid: true,
            inputSize: "lg",
            class: "tw:pr-10"
        }
    ],

    defaultVariants: {
        inputSize: "md",
        inputType: "default"
    }
});
